import { END_POINTS } from "../helpers";
import emptySplitApi from "../utils/rtk";

type CommonResponseType = {
  data: any;
  status: number;
  message: string;
};

// type Body={
//     start:number,
//     length:number,
//     search:string
// }

export const subAdminApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    allSubAdmin: builder.mutation<CommonResponseType, {}>({
      query: (body) => ({
        url: END_POINTS.allSubAdmin,
        method: "POST",
        body,
      }),
    }),
    subAdminById: builder.query({
      query: (id) => ({
        url: `${END_POINTS.subadminById}/${id}/`,
        method: "GET",
      }),
    }),
    addSubAdmin: builder.mutation<CommonResponseType, {}>({
      query: (body) => ({
        url: END_POINTS.addSubAdmin,
        method: "POST",
        body,
      }),
    }),
    deleteSubAdmin: builder.mutation({
      query: (id) => ({
        url: `${END_POINTS.deleteSubAdmin}${id}/`,
        method: "DELETE",
      }),
    }),
    updateSubAdmin: builder.mutation<
      CommonResponseType,
      { id: any; body: any }
    >({
      query: ({ id, body }) => ({
        url: `${END_POINTS.updateSubAdmin}${id}/`,
        method: "PUT",
        body,
      }),
    }),
    updateSubAdminStatus: builder.mutation<
      CommonResponseType,
      { id: any; body: { is_active: boolean } }
    >({
      query: ({ id, body }) => ({
        url: `${END_POINTS.updateSubAdminStatus}${id}/`,
        method: "PUT",
        body,
      }),
    }),
    allSubRole: builder.query<CommonResponseType, void>({
      query: () => ({
        url: END_POINTS.allSubRole,
        method: "GET",
      }),
    }),
    addSubRole: builder.mutation<CommonResponseType, {}>({
      query: (body) => ({
        url: END_POINTS.addSubRole,
        method: "POST",
        body,
      }),
    }),
    deleteSubRole: builder.mutation<CommonResponseType, {}>({
      query: (id) => ({
        url: `${END_POINTS.deleteSubRole}/${id}/`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useAllSubAdminMutation,
  useLazySubAdminByIdQuery,
  useAddSubAdminMutation,
  useDeleteSubAdminMutation,
  useUpdateSubAdminMutation,
  useUpdateSubAdminStatusMutation,
  useLazyAllSubRoleQuery,
  useAddSubRoleMutation,
  useDeleteSubRoleMutation,
} = subAdminApi;
